<script lang="ts" setup>
import { useFlag } from '@unleash/proxy-client-vue'
import { onClickOutside } from '@vueuse/core'

const menuRef = ref()
const route = useRoute()
const isMenuOpen = ref(false)
const isMobile = useIsMobile()
const globalStore = useGlobalStore()
const isGlobalCouponsEnabled = useFlag('storefront.global-coupons')

const isLogoVisible = computed(() => !route.meta.noLogo)
const isLinksVisible = computed(() => !route.meta.noLinks)
const isCartButtonEnabled = computed(() => globalStore.isCheckoutEnabled && route.meta.showCart)
const isCouponButtonEnabled = computed(() => isGlobalCouponsEnabled.value && route.meta.showCart)
const shouldDisplayBackButton = computed(() => route.meta.nested || isMobile.value)

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value
}

onClickOutside(menuRef, () => {
  if (!isMenuOpen.value) return

  isMenuOpen.value = false
})

const isShareButtonEnabled = computed(() => route.meta.shareable)
const isAdBannerEnabled = useFlag('storefront.ad-banner')
</script>

<template>
  <div ref="menuRef" class="sticky left-0 top-0 z-30 w-full">
    <ClientOnly>
      <RAdBanner v-if="isAdBannerEnabled && !globalStore.store.isAdFree" />
      <header class="app-header flex h-16 items-center gap-2 rounded-b-lg sm:h-20">
        <div
          class="m-auto grid h-14 w-full items-center justify-between px-4 py-3 sm:px-10 xl:w-[1280px]"
          :class="{
            'grid-cols-3': shouldDisplayBackButton && isLogoVisible,
            'grid-cols-2': !shouldDisplayBackButton || !isLogoVisible,
          }"
        >
          <div v-if="shouldDisplayBackButton" class="flex gap-4">
            <RAppMenuNavigationButton :is-menu-open="isMenuOpen" @toggle-menu="toggleMenu" />
          </div>
          <div
            v-if="isLogoVisible"
            class="flex items-center"
            :class="{
              'justify-center': shouldDisplayBackButton,
            }"
          >
            <RStoreLogo salesperson-class="!text-lg" />
          </div>

          <div class="flex items-center justify-end gap-4">
            <RHeaderLinks v-if="!isMobile && isLinksVisible" />
            <RMenuShareButton v-if="isShareButtonEnabled" class="max-sm:hidden" />
            <div class="flex items-center gap-0">
              <RCouponButton v-if="isCouponButtonEnabled" />
              <RCartButton v-if="isCartButtonEnabled" />
            </div>
          </div>
        </div>
      </header>

      <RBaseDrawer
        :show="isMenuOpen"
        placement="left"
        :title="$t('components.aboutUs.sectionOne.title')"
        class="max-w-[390px] !rounded-l-none !rounded-br-2xl"
        with-backdrop
      >
        <div class="max-h-full overflow-auto bg-aqua-haze pb-12">
          <RAboutUs no-title />
        </div>
      </RBaseDrawer>
    </ClientOnly>
  </div>
</template>

<style scoped>
.app-header {
  background-color: var(--color-primary);
  color: var(--color-text);
}
</style>
